/** Inclusive lower bound for slider range settings (product). */
export const SLIDER_VALUE_MIN_FLOOR = 0

/** Inclusive upper bound for slider range settings (product). */
export const SLIDER_VALUE_MAX_CEILING = 100

/** Default minimum when the field is empty (placeholder shows `0`). */
export const SLIDER_DEFAULT_MIN_VALUE = 0

/** Default maximum when the field is empty (placeholder shows `10`). */
export const SLIDER_DEFAULT_MAX_VALUE = 10

function parseNonNegativeWholeNumberField(s: string): number | null {
  const t = s.trim()
  if (!t) return null
  if (!/^(?:0|[1-9]\d*)$/.test(t)) return null
  const n = Number(t)
  return Number.isFinite(n) && Number.isInteger(n) ? n : null
}

/** Parse a non-negative whole-number min field; empty → `null`. */
export function parseSliderMinField(s: string): number | null {
  return parseNonNegativeWholeNumberField(s)
}

/** Parse a non-negative whole-number max field; empty → `null`. */
export function parseSliderMaxField(s: string): number | null {
  return parseNonNegativeWholeNumberField(s)
}

export function effectiveSliderMinValue(s: string): number {
  return parseSliderMinField(s) ?? SLIDER_DEFAULT_MIN_VALUE
}

export function effectiveSliderMaxValue(s: string): number {
  return parseSliderMaxField(s) ?? SLIDER_DEFAULT_MAX_VALUE
}

/** Inclusive span between effective min and max (max − min). */
export function sliderInclusiveSpan(minValue: string, maxValue: string): number {
  return effectiveSliderMaxValue(maxValue) - effectiveSliderMinValue(minValue)
}

/** Default inclusive span when min/max fields are empty (effective 0–10). */
export const SLIDER_DEFAULT_INCLUSIVE_SPAN = sliderInclusiveSpan('', '')

export function parseSliderStepField(s: string): number | null {
  const t = s.trim()
  if (!t || !/^[1-9]\d*$/.test(t)) return null
  const n = Number(t)
  return Number.isFinite(n) && Number.isInteger(n) && n >= 1 ? n : null
}

/** Sanitize min input: digits only, non-negative (no `-`). */
export function sanitizeSliderMinFieldInput(s: string): string {
  return s.replaceAll(/\D/g, '').slice(0, 11)
}

/** Sanitize max input: digits only, clamp to {@link SLIDER_VALUE_MAX_CEILING}. */
export function sanitizeSliderMaxFieldInput(s: string): string {
  const digits = s.replaceAll(/\D/g, '').slice(0, 11)
  if (!digits) return ''
  const n = Number(digits)
  if (!Number.isFinite(n)) return digits
  if (n > SLIDER_VALUE_MAX_CEILING) return String(SLIDER_VALUE_MAX_CEILING)
  return digits
}
